import React from "react";
import classes from "./Checkbox.css";

const Checkbox = (props) => {
  return (
    <div
      className={
        props.checked
          ? `${classes.Checkbox} ${classes.Checked}`
          : classes.Checkbox
      }
    >
      <input
        id={props.id}
        type="checkbox"
        value={props.value}
        name={props.id}
        checked={props.checked}
        onChange={props.onChange}
      />
      <div className={classes.CheckboxDisplay} />
    </div>
  );
};

export default Checkbox;
